// extracted by mini-css-extract-plugin
module.exports = {"floatingFooter":"floating-footer__floatingFooter___1aZ8_","show":"floating-footer__show___vJimH","contentWrapper":"floating-footer__contentWrapper___1ZJuV"};